import { render } from "./UploadingFiles.vue?vue&type=template&id=1fc5191c"
import script from "./UploadingFiles.vue?vue&type=script&lang=js"
export * from "./UploadingFiles.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__